import React from 'react';
import { Button } from '@sm/wds-react';
import { IconX, IconArrowDown, IconArrowUp } from '@sm/wds-icons';
import { PropTypes } from 'prop-types';

export const ChoiceOptions = ({ index, questionAnswersLength, moveAnswer, deleteAnswer }) => (
  <div className="sm-new-survey__choice-options">
    {index !== 0 && (
      <Button
        className="sm-new-survey__choice-options-button"
        size="sm"
        variant="text"
        onClick={() => moveAnswer(index)}
        tabIndex="-1"
      >
        <span className="sm-new-survey__choice-options-button-icon">
          <IconArrowUp />
        </span>
      </Button>
    )}
    {index !== questionAnswersLength - 1 && (
      <Button
        className="sm-new-survey__choice-options-button"
        size="sm"
        variant="text"
        onClick={() => moveAnswer(index, true)}
        tabIndex="-1"
      >
        <span className="sm-new-survey__choice-options-button-icon">
          <IconArrowDown />
        </span>
      </Button>
    )}
    {questionAnswersLength > 2 && (
      <Button
        className="sm-new-survey__choice-options-button"
        size="sm"
        variant="text"
        onClick={() => deleteAnswer(index)}
        tabIndex="-1"
      >
        <span className="sm-new-survey__choice-options-button-icon">
          <IconX />
        </span>
      </Button>
    )}
  </div>
);

ChoiceOptions.propTypes = {
  index: PropTypes.number,
  questionAnswersLength: PropTypes.number,
  moveAnswer: PropTypes.func,
  deleteAnswer: PropTypes.func,
};

ChoiceOptions.defaultProps = {
  index: 0,
  questionAnswersLength: 0,
  moveAnswer: () => {},
  deleteAnswer: () => {},
};

export default ChoiceOptions;
